/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jsPDF } from "jspdf";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx-js-style";
import autoTable from "jspdf-autotable";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./LoanReportTest.css";
import { ArrowLeftIcon, ArrowRightIcon, Download, FileTextIcon } from "lucide-react";

const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50,100,"All"];
const API_URL = "https://payyug.in/api";

const ForceCloser = () => {
  const navigate = useNavigate();
    const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  const [centers, setCenters] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loanType, setLoanType] = useState("");
    const [company, setCompany] = useState(null);

  const [loans, setLoans] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [showForceCloseModal, setShowForceCloseModal] = useState(false);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [emiList, setEmiList] = useState([]);
  const [forceCloseAmount, setForceCloseAmount] = useState(0);
  const [reason, setReason] = useState("");
  const [loadingClose, setLoadingClose] = useState(false);

  
  useEffect(() => {
    const fetchCompany = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`,
        );
        const data = await response.json();

        if (response.ok && data) {
          // Dynamically construct logo URL
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
          }
          setCompany(data);
        } else {
          console.error("Failed to fetch company data");
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      } finally {
        setLoading(false);
      }
    };

    if (superAdminId) fetchCompany();
  }, [superAdminId]);

  /* ================= FETCH Branch ================= */
  useEffect(() => {
    const fetchBranch = async () => {
      try {
        const res = await axios.get(`${API_URL}/get-branch`, {
          params: {
            SuperAdminId: localStorage.getItem("adminuserId"),
            limit: "all",
          },
        });
        setBranchs(res?.data.branches || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchBranch();
  }, []);

  /* ================= FETCH CENTERS ================= */
  useEffect(() => {
    if (!selectedBranch?.id) return;

    const fetchCenters = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");
        if (!superAdminId) return;

        const res = await axios.get(`${API_URL}/group/centre`, {
          params: {
            superAdminId,
            branchid: selectedBranch.id,
            limit: 100000,
          },
        });

        setCenters(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchCenters();
  }, [selectedBranch]);

  /* ================= FETCH GROUPS ================= */
  useEffect(() => {
    if (!selectedCenter) return;

    const fetchGroups = async () => {
      try {
        const superAdminId = localStorage.getItem("adminuserId");

        const res = await axios.get(`${API_URL}/groupupdate/getall`, {
          params: {
            superAdminId,
            CenterId:
              selectedCenter.id === "all" ? "" : selectedCenter.id || "",
            limit: 100000,
          },
        });

        setGroups(res.data?.data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchGroups();
  }, [selectedCenter]);

  /* ================= FETCH LOANS ================= */
  const fetchLoans = async (page = 1, limit = rowsPerPage) => {
    try {
      setLoading(true);
      setError(null);

      const token = localStorage.getItem("authToken");
      const superAdminId = localStorage.getItem("adminuserId");

      const res = await axios.get(`${API_URL}/group-loan/group/list`, {
        params: {
          superAdminId,
          branchId: selectedBranch?.id,
          centerId: selectedCenter?.id === "all" ? "" : selectedCenter?.id,
          groupId: selectedGroup?.id === "all" ? "" : selectedGroup?.id,
          loanType: loanType === "ALL" ? undefined : loanType,
          page,
          limit:limit==="All"?100000:limit,
        },
        headers: { Authorization: `Bearer ${token}` },
      });

      const activeData = res.data?.data.filter(
        (a) => a.status.toLowerCase() === "active",
      );

      setLoans(activeData || res.data?.data || []);
      setTotalPages(res.data?.totalPages || 1);
      setCurrentPage(res.data?.currentPage || 1);
    } catch (err) {
      setError("Failed to fetch loans");
    } finally {
      setLoading(false);
    }
  };

const fetchEmiList = async (loanAccountId) => {
  try {
    const token = localStorage.getItem("authToken");
    const adminId = localStorage.getItem("adminuserId");

    const res = await axios.get(
      `${API_URL}/group-loan/emi/list`,
      {
        params: {
          superAdminId: adminId ? Number(adminId) : 14,
          grouploanAccountId: loanAccountId,
          limit: 100000,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    const emi = res.data?.data || [];
    setEmiList(emi);

    const paid = emi.filter(x => x.status?.toLowerCase() === "paid");
    
    let pendingEmiNo = 1;
    
    if (paid.length > 0) {
      const lastPaid = paid[paid.length - 1];
      pendingEmiNo = Number(lastPaid.installmentNo || lastPaid.emiNo || 0) + 1;
    }

    const pending = emi.find(x => 
      Number(x.installmentNo) === pendingEmiNo || Number(x.emiNo) === pendingEmiNo
    );

    if (pending) {
      setForceCloseAmount(Number(pending.outstanding || 0));
    } else {
      setForceCloseAmount(0);
    }

  } catch (err) {
    console.error("EMI Fetch Error:", err);
    toast.error("Unable to fetch EMI.");
  }
};

  /* ================= HANDLE FORCE CLOSE SUBMIT ================= */
  const handleForceCloseSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      toast.error("Please enter a reason for closure.");
      return;
    }

    try {
      setLoadingClose(true);
      const token = localStorage.getItem("authToken");
      const adminId = localStorage.getItem("adminuserId") || 5;

      const payload = {
        loanAccountId: selectedLoan.id, 
        status: "FORCE_CLOSED",
        reason: reason,
        closureAmount: Number(forceCloseAmount),
        updatedBy: Number(adminId)
      };

      const res=await axios.post(`${API_URL}/group-loan/force-close-account`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success(res.data?.message||"Loan Force Closed successfully!");
      setShowForceCloseModal(false);
      setReason("");
      
      // Refresh list
      fetchLoans(currentPage, rowsPerPage);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to force close loan.");
    } finally {
      setLoadingClose(false);
    }
  };


  /* ================= FILTER ================= */
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedBranch || !selectedCenter) {
      toast.error("Please select Branch and Center before filtering.");
      return;
    }

    setCurrentPage(1);
    fetchLoans(1, rowsPerPage);
  };

  /* ================= ITEMS PER PAGE ================= */
  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    setRowsPerPage(value==="All"?"All":Number(value));
    setCurrentPage(1);

    if (selectedBranch && selectedCenter) {
      fetchLoans(1, value);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    return new Date(dateStr).toLocaleDateString("en-GB");
  };

  const filteredLoans =
    loanType === "" || loanType === "ALL"
      ? loans
      : loans.filter((loan) =>
          (loan.loanType || "")
            .toLowerCase()
            .startsWith(loanType.toLowerCase()),
        );

        
                  const handleDownloadPDF = async () => {
                    const doc = new jsPDF("p", "mm", "a4");
                    const pageWidth = doc.internal.pageSize.width;
                    const pageHeight = doc.internal.pageSize.height;
                
                    // ================= LOGO =================
                    const logoX = 15;
                    const logoY = 12;
                    const logoSize = 25;
                    const logoPadding = 2;
                
                    // Border color & thickness
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.2);
                
                    // Calculate center of logo
                    const centerX = logoX + logoSize / 2;
                    const centerY = logoY + logoSize / 2;
                
                    // Radius = half of logo + padding
                    const radius = logoSize / 2 + logoPadding;
                
                    // Draw circle
                    doc.circle(centerX, centerY, radius);
                
                    // Logo image
                    if (company?.logoUrl) {
                      try {
                        const logoResp = await fetch(company.logoUrl);
                        const logoBlob = await logoResp.blob();
                        const reader = new FileReader();
                        await new Promise((resolve) => {
                          reader.onload = () => {
                            doc.addImage(
                              reader.result,
                              "PNG",
                              logoX,
                              logoY,
                              logoSize,
                              logoSize,
                            );
                            resolve();
                          };
                          reader.readAsDataURL(logoBlob);
                        });
                      } catch {
                        // silent fail
                      }
                    }
                
                    // ================= COMPANY NAME (AUTO WRAP) =================
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(14);
                
                    const nameX = logoX + logoSize + 5;
                    const nameY = 18;
                    const nameMaxWidth = pageWidth - nameX - 15;
                
                    const companyNameText = doc.splitTextToSize(
                      (company?.name || "COMPANY NAME").toUpperCase(),
                      nameMaxWidth,
                    );
                
                    doc.text(companyNameText, nameX, nameY);
                
                    // Calculate Y after company name
                    let currentY = nameY + companyNameText.length * 6;
                
                    // ================= COMPANY DETAILS =================
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(11);
                
                    const detailX = nameX;
                    const detailMaxWidth = nameMaxWidth;
                
                    // Address
                    const addressText = doc.splitTextToSize(
                      company?.address || "Company Address",
                      detailMaxWidth,
                    );
                    doc.text(addressText, detailX, currentY);
                    currentY += addressText.length * 5;
                
                    // Email
                    const emailText = doc.splitTextToSize(
                      `Email: ${company?.email || "-"}`,
                      detailMaxWidth,
                    );
                    doc.text(emailText, detailX, currentY);
                    currentY += emailText.length * 5;
                
                    // Phone
                    const phoneText = doc.splitTextToSize(
                      `Phone: ${company?.contact || "-"}`,
                      detailMaxWidth,
                    );
                    doc.text(phoneText, detailX, currentY);
                    currentY += phoneText.length * 5;
                
                    // Divider
                    doc.line(10, currentY + 4, pageWidth - 10, currentY + 4);
                
                    // ================= REPORT TITLE =================
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(13);
                    doc.text("Group Loan Force Closer Report", pageWidth / 2, currentY + 14, {
                      align: "center",
                    });
                
                    const tableColumn = [
                      "SN",
                      "Account No",
                      "Loan Type",
                      "Loan Amount",
                      "Center",
                      "Group",
                      "Member",
                      "Mobile",
                      "Emi Amount",
                      "Disbursal Date",
                      "First Emi Date",
                      "Status",
                    ];
                
                    const tableRows = filteredLoans.map((item, index) => [
                      index + 1,
                      item?.loanAccountNumber || "N/A",
                      item?.loanType?`Group Loan (${item?.loanType})`:"N/A",
                      item?.loanAmount ? item?.loanAmount : 0,
                      item?.centerName || "N/A",
                      item?.groupName || "N/A",
                      item?.memberName || "N/A",
                      item.member?.mobileNumber || "N/A",
                      item.loanEmiAmount ? item.loanEmiAmount : 0,
                      item.disbursalDate ? new Date(item.disbursalDate).toLocaleDateString("en-GB") : "N/A",
                      item.disbursedfirstDate ? new Date(item.disbursedfirstDate).toLocaleDateString("en-GB") : "N/A",
                      item.status || "N/A",
                    ]);
                
                    autoTable(doc, {
                      startY: currentY + 20,
                      head: [tableColumn],
                      body: tableRows,
                
                      theme: "grid",
                      styles: {
                        fontSize: 7,
                        cellPadding: 3,
                        halign: "center",
                      },
                      headStyles: {
                        fontStyle: "bold",
                        fontSize: 7,
                      },
                      alternateRowStyles: {
                        fillColor: [245, 245, 245],
                      },
                
                      didDrawPage: function () {
                        const pageWidth = doc.internal.pageSize.width;
                        const pageHeight = doc.internal.pageSize.height;
                
                        doc.setDrawColor(0);
                        doc.setLineWidth(0.2);
                
                        // Page border on EVERY page
                        doc.rect(8, 8, pageWidth - 16, pageHeight - 16);
                      },
                    });
                
                    // ================= FOOTER =================
                    const pageCount = doc.internal.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                      doc.setPage(i);
                      doc.setFontSize(8);
                      doc.setTextColor(100);
                      doc.text(`Page ${i} of ${pageCount}`, pageWidth - 30, pageHeight - 10);
                      doc.text("Generated by Collection System", 14, pageHeight - 10);
                    }
                
                    doc.save("Group_Loan_ForceClose_Report.pdf");
                  };
                
                  const exportExcel = () => {
                    const data = filteredLoans.map((item) => ({
                      "State": item.member?.state || "N/A",
                      "Region": selectedBranch?.name || "N/A",
                      "Branch": selectedBranch?.name || "N/A",
                      "Account No": item?.loanAccountNumber || "N/A",
                      "Loan Type": item?.loanType?`Group Loan (${item?.loanType})`:"N/A",
                      "Loan Amount": item?.loanAmount
                        ? item?.loanAmount
                        : 0,
                      "Center Name": item?.centerName || "N/A",
                      "Group Name": item?.groupName || "N/A",
                      "Member Name": item?.memberName || "N/A",
                      "Mobile No.": item.member?.mobileNumber || "N/A",
                      "Emi Amount": item.loanEmiAmount ? item.loanEmiAmount : 0,
                      "Applied Date": item.loanAppliedDate
                        ? new Date(item.loanAppliedDate).toLocaleDateString("en-GB")
                        : "N/A",
                      "Approval Date": item.approvalDate
                        ? new Date(item.approvalDate).toLocaleDateString("en-GB")
                        : "N/A",
                      "Disbursal Date": item.disbursalDate
                        ? new Date(item.disbursalDate).toLocaleDateString("en-GB")
                        : "N/A",
                      "First Emi Date": item?.disbursedfirstDate
                        ? new Date(item?.disbursedfirstDate).toLocaleDateString("en-GB")
                        : "N/A",
                    Status: item.status || "N/A",
                    }));
                
                    const worksheet = XLSX.utils.json_to_sheet(data);
                
                    // 🔹 Header styling
                    const headerCells = Object.keys(data[0]);
                    headerCells.forEach((_, index) => {
                      const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
                      worksheet[cellRef].s = {
                        font: {
                          bold: true,
                          color: { rgb: "FFFFFF" },
                        },
                        fill: {
                          fgColor: { rgb: "1F4E78" },
                        },
                        alignment: {
                          horizontal: "center",
                          vertical: "center",
                        },
                      };
                    });
                
                    // 🔹 Auto column width
                    worksheet["!cols"] = headerCells.map((key) => ({
                      wch: Math.max(key.length + 5, 18),
                    }));
                
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Loan Report");
                
                    XLSX.writeFile(workbook, "Group_Loan_ForceClose_Report.xlsx");
                  };

  return (
    <div className="loan-report-container">
      {/* Back wrapper */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "8px 16px",
          backgroundColor: "#fff",
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          marginBottom: "20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
        }}
      >
        <ArrowLeftIcon
          onClick={() => navigate(-1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />

        <h2
          style={{
            margin: 0,
            fontSize: "18px",
            fontWeight: "600",
            color: "#333",
          }}
        >
          Group Loan Force Closer
        </h2>

        <ArrowRightIcon
          onClick={() => navigate(1)}
          style={{
            cursor: "pointer",
            padding: "4px",
            borderRadius: "4px",
            transition: "background-color 0.2s",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.backgroundColor = "#f5f5f5")
          }
          onMouseLeave={(e) =>
            (e.currentTarget.style.backgroundColor = "transparent")
          }
        />
      </div>
      <section className="loan-report-filter-section">
        {/* <h2 className="loan-report-title">Force Closer Filter</h2>
        <p className="loan-report-subtitle">
          Use filter to see more precise report
        </p> */}

        <form className="loan-report-form" onSubmit={handleSubmit}>
          <div className="loan-report-grid">
            {/* Branch */}
            <div className="loan-report-form-group">
              <label>Select Branch</label>
              <select
                value={selectedBranch?.id || ""}
                onChange={(e) => {
                  const branch = branchs.find(
                    (br) => br.id === Number(e.target.value),
                  );
                  setSelectedBranch(branch);
                  setSelectedCenter(null);
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Branch</option>
                {branchs.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </div>

            {/* Center */}
            <div className="loan-report-form-group">
              <label>Select Center</label>
              <select
                value={selectedCenter?.id || ""}
                disabled={!selectedBranch}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedCenter({ id: "all", CenterName: "All" });
                  } else {
                    const center = centers.find((cn) => cn.id === Number(val));
                    setSelectedCenter(center);
                  }
                  setSelectedGroup(null);
                  setLoans([]);
                }}
              >
                <option value="">Select Center</option>
                <option value="all">All Centers</option>
                {centers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.CenterName}
                  </option>
                ))}
              </select>
            </div>

            {/* Group */}
            <div className="loan-report-form-group">
              <label>Select Group</label>
              <select
                value={selectedGroup?.id || ""}
                disabled={!selectedCenter}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "all") {
                    setSelectedGroup({ id: "all", groupname: "All" });
                  } else {
                    const group = groups.find((gr) => gr.id === Number(val));
                    setSelectedGroup(group);
                  }
                  setLoans([]);
                }}
              >
                <option value="">Select Group</option>
                <option value="all">All Groups</option>
                {groups.map((g) => (
                  <option key={g.id} value={g.id}>
                    {g.groupname}
                  </option>
                ))}
              </select>
            </div>
            {/* Loan Type */}
            <div className="loan-report-form-group">
              <label>Loan Type</label>
              <select
                value={loanType}
                onChange={(e) => {
                  setLoanType(e.target.value);
                }}
              >
                <option value="ALL">All</option>
                <option value="FIXED">Fixed</option>
                <option value="INDIVIDUAL">Individual</option>
              </select>
            </div>
          </div>

          <button type="submit" className="loan-report-submit-btn">
            Filter
          </button>
        </form>
      </section>

      {/* ================= TABLE ================= */}
      <section className="loan-report-details-section">
        <div className="loan-report-table-header">
          <div>
            <label>Show </label>
            <select onChange={handleItemsPerPageChange} value={rowsPerPage}>
              {ITEMS_PER_PAGE_OPTIONS.map((count) => (
                <option key={count} value={count}>
                  {count}
                </option>
              ))}
            </select>
            <span> entries</span>
          </div>
              {filteredLoans.length > 0 && (
                    <div
                      className=""
                      style={{ display: "flex", gap: "5px", marginTop: "10px" }}
                    >
                      <button
                        className="collection-report-filter-btn"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        onClick={exportExcel}
                      >
                        <FileTextIcon size={18} /> Excel
                      </button>
                      <button
                        className="collection-report-filter-btn"
                        style={{ display: "flex", alignItems: "center", gap: "5px" }}
                        onClick={handleDownloadPDF}
                      >
                        <Download size={18} /> PDF
                      </button>
                    </div>
                  )}
        </div>

        <div className="loan-report-table-container">
          <table className="loan-report-table">
            <thead>
              <tr>
                <th>SN</th>
                <th>Loan Account No</th>
                <th>Center Name</th>
                <th>Group Name</th>
                <th>Member Name</th>
                <th>Loan Amount</th>
                <th>EMI Amount</th>
                <th>Total Payable</th>
                <th>Applied Date</th>
                <th>Approval Date</th>
                <th>Disbursal Date</th>
                <th>First Emi Date</th>
                <th>Loan Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="17">Loading...</td>
                </tr>
              ) : error ? (
                <tr>
                  <td colSpan="17">{error}</td>
                </tr>
              ) : filteredLoans.length === 0 ? (
                <tr>
                  <td colSpan="17">No data available</td>
                </tr>
              ) : (
                filteredLoans.map((loan, index) => {
                  const status = loan.status?.toLowerCase();

                  return (
                    <tr key={loan.id}>
                      <td>{rowsPerPage==="All"?index+1:(currentPage - 1) * rowsPerPage + index + 1}</td>
                      <td>{loan.loanAccountNumber || "N/A"}</td>
                      <td>{loan.centerName || "N/A"}</td>
                      <td>{loan.groupName || "N/A"}</td>
                      <td>{loan.memberName || "N/A"}</td>
                      <td>{loan.loanAmount || "N/A"}</td>
                      <td>{loan.loanEmiAmount || "N/A"}</td>
                      <td>{loan.loanPayable || "N/A"}</td>
                      <td>{formatDate(loan.loanAppliedDate)}</td>
                      <td>{formatDate(loan.approvalDate)}</td>
                      <td>{formatDate(loan.disbursalDate)}</td>
                      <td>{formatDate(loan.disbursedfirstDate)}</td>
                      <td>{loan.status || "N/A"}</td>

                      <td>
                        <button
                          className="force-close-action-btn"
                          onClick={() => {
                            setSelectedLoan(loan);
                            setShowForceCloseModal(true);
                            fetchEmiList(loan.id); 
                          }}
                        >
                          Force Close
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </section>

      {/* ================= PAGINATION ================= */}
      {rowsPerPage!=="All" && totalPages > 1 && loans.length > 0 && (
        <div className="loan-report-pagination">
          <button
            onClick={() => {
              const newPage = currentPage - 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === 1}
          >
            ⬅ Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={() => {
              const newPage = currentPage + 1;
              setCurrentPage(newPage);
              fetchLoans(newPage, rowsPerPage);
            }}
            disabled={currentPage === totalPages}
          >
            Next ➡
          </button>
        </div>
      )}

      {/* ================= FORCE CLOSE MODAL ================= */}
      {showForceCloseModal && selectedLoan && (
  <div className="pylf-modal-backdrop">
    <div className="pylf-modal-content">
      <div className="pylf-modal-header">
        <h3>Force Close Loan Account</h3>
        <button className="pylf-close-btn" onClick={() => setShowForceCloseModal(false)}>×</button>
      </div>
      
      <form onSubmit={handleForceCloseSubmit}>
        <div className="pylf-modal-body">
          {/* Loan Info Summary */}
          <div className="pylf-loan-summary-box">
            <p><strong>Account No:</strong> <span>{selectedLoan.loanAccountNumber}</span></p>
            <p><strong>Center Name:</strong> <span>{selectedLoan.centerName}</span></p>
            <p><strong>Group Name:</strong> <span>{selectedLoan.groupName}</span></p>
            <p><strong>Member Name:</strong> <span>{selectedLoan.memberName}</span></p>
            <p><strong>Loan Amount:</strong> <span>₹{selectedLoan.loanAmount}</span></p>
            {/* <p><strong>Total Payable:</strong> <span>₹{selectedLoan.loanPayable}</span></p> */}
          </div>

          <hr />

          {/* Dynamic data fetched from EMI List */}
          <div className="pylf-form-group">
            <label>Calculated Closure Amount (Outstanding)</label>
            <input 
              type="number" 
              value={forceCloseAmount} 
              disabled 
              className="pylf-disabled-input"
            />
            <small className="pylf-help-text">Based on the next pending EMI's outstanding amount.</small>
          </div>

          <div className="pylf-form-group">
            <label>Reason for Force Closure <span className="pylf-required">*</span></label>
            <select 
              value={reason} 
              onChange={(e) => setReason(e.target.value)}
              required
            >
              <option value="">-- Select Reason --</option>
              <option value="Customer Death">Customer Death</option>
              <option value="Pre-payment / Settled">Pre-payment / Settled</option>
              <option value="Bad Debt / Write Off">Bad Debt / Write Off</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {reason === "Other" && (
            <div className="pylf-form-group">
              <label>Specify Custom Reason</label>
              <input 
                type="text" 
                placeholder="Enter details..." 
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>
          )}
        </div>

        <div className="pylf-modal-footer">
          <button type="button" className="pylf-btn-secondary" onClick={() => setShowForceCloseModal(false)}>
            Cancel
          </button>
          <button type="submit" className="pylf-btn-danger" disabled={loadingClose}>
            {loadingClose ? "Closing..." : "Confirm Force Close"}
          </button>
        </div>
      </form>
    </div>
  </div>
)}

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default ForceCloser;